import { apiCampOrderHasUnpaid } from '@/api/API';

export default {
    namespaced: true,
    state: {
        hasUnpaid: false,
        hasUnpaidSurcharge: false,
        hasPendingRefund: false,
    },
    getters: {
        // 會員營隊待辦：待付款訂單、補收款待繳、退費待處理，任一即為 true。
        hasCampTodo(state) {
            return state.hasUnpaid || state.hasUnpaidSurcharge || state.hasPendingRefund;
        },
    },
    mutations: {
        setHasUnpaid(state, val) {
            state.hasUnpaid = val;
        },
        setTodoFlags(state, payload) {
            state.hasUnpaid = !!(payload && payload.hasUnpaid);
            state.hasUnpaidSurcharge = !!(payload && payload.hasUnpaidSurcharge);
            state.hasPendingRefund = !!(payload && payload.hasPendingRefund);
        },
    },
    actions: {
        async fetchHasUnpaid({ commit }) {
            try {
                const res = await apiCampOrderHasUnpaid();
                commit('setTodoFlags', res.data || {});
            } catch {
                commit('setTodoFlags', {});
            }
        },
    },
};
